import React from "react";

import { encodeSearchTerms } from "@cayuse/shared-react.utils.helpers";
import { executeRequest } from "@cayuse/shared-react.utils.http";
import { API_ORGANIZATION } from "globals/constants";
import { spUrl, escapeForElasticSearchQuery } from "./helpers";


export const searchOrganizations = (searchText) => {
	const searchTerms = [{ key: "name", val: `${escapeForElasticSearchQuery(searchText.toLocaleLowerCase()).trim()}` }];

	const search = encodeSearchTerms(searchTerms);

	const url = spUrl(`${API_ORGANIZATION}?search=${search}`);

	return executeRequest(url)
		.then((response) => {
			const options = (response.content ?? []).map((organization) => {
				return {
					key: organization.id,
					value: organization.id,
					text: organization.name,
					organization: organization,
					content: (
						<div className="optionContent">
							<span>{organization.name}</span>
						</div>
					),
				};
			});

			return { options, hiddenOptionsCount: response.totalPages > 1 && response.totalElements - response.content.length };
		});
}
